import { BrowserRouter } from 'react-router-dom';

import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import RouteChange from './components/layout/RouteChange';
import RouteTable from './routes';
import { LeanProvider } from './context/LeanContext';

const App = () => (
  <BrowserRouter>
    <LeanProvider>
      <a className="skip-link" href="#main">Skip to content</a>
      <RouteChange />
      <Navbar />
      <RouteTable />
      <Footer />
    </LeanProvider>
  </BrowserRouter>
);

export default App;
